import { render, staticRenderFns } from "./PointModal.vue?vue&type=template&id=4a7a1fee&scoped=true&"
import script from "./PointModal.vue?vue&type=script&lang=js&"
export * from "./PointModal.vue?vue&type=script&lang=js&"
import style0 from "./PointModal.vue?vue&type=style&index=0&id=4a7a1fee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a1fee",
  null
  
)

export default component.exports